module.exports = __webpack_public_path__ + "media/bg_sound.ff6f2ae4.mp3";